import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <div align="center">
  <h1>react-hooks-testing-library</h1>
  <a href="https://www.emojione.com/emoji/1f40f">
    <img height="80" width="80" alt="ram" src="https://raw.githubusercontent.com/mpeyper/react-hooks-testing-library/main/public/ram.png" />
  </a>
  <p>
    Simple and complete React hooks testing utilities that encourage good testing practices.
  </p>
    </div>
    <hr />
    <h2 {...{
      "id": "the-problem"
    }}>{`The problem`}</h2>
    <p>{`You're writing an awesome custom hook and you want to test it, but as soon as you call it you see
the following error:`}</p>
    <blockquote>
      <p parentName="blockquote">{`Invariant Violation: Hooks can only be called inside the body of a function component.`}</p>
    </blockquote>
    <p>{`You don't really want to write a component solely for testing this hook and have to work out how you
were going to trigger all the various ways the hook can be updated, especially given the
complexities of how you've wired the whole thing together.`}</p>
    <h2 {...{
      "id": "the-solution"
    }}>{`The solution`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`react-hooks-testing-library`}</inlineCode>{` allows you to create a simple test harness for React hooks that
handles running them within the body of a function component, as well as providing various useful
utility functions for updating the inputs and retrieving the outputs of your amazing custom hook.
This library aims to provide a testing experience as close as possible to natively using your hook
from within a real component.`}</p>
    <p>{`Using this library, you do not have to concern yourself with how to construct, render or interact
with the react component in order to test your hook. You can just use the hook directly and assert
the results.`}</p>
    <h3 {...{
      "id": "when-to-use-this-library"
    }}>{`When to use this library`}</h3>
    <ol>
      <li parentName="ol">{`You're writing a library with one or more custom hooks that are not directly tied to a component`}</li>
      <li parentName="ol">{`You have a complex hook that is difficult to test through component interactions`}</li>
    </ol>
    <h3 {...{
      "id": "when-not-to-use-this-library"
    }}>{`When not to use this library`}</h3>
    <ol>
      <li parentName="ol">{`Your hook is defined alongside a component and is only used there`}</li>
      <li parentName="ol">{`Your hook is easy to test by just testing the components using it`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      